<template>
  <Row>
    <Column :width="15">
      <div id="detailsModal" class="rc-modal-dialog">
        <!-- Modal content -->
        <div class="rc-modal-content-dialog-small">
          <div class="rc-modal-header-dialog">
            <Box :key="redraw">
              <Row v-for="(row, rowIndex) in viewHeaderData" :key="rowIndex">
                <CellFactory :rowData="row.data" :showMissingRequirements="showMissingRequirements"
                  v-on:withValue="withFieldValue" v-on:withButtonPressed="withButtonPressed" />
              </Row>
            </Box>
          </div>

          <div class="rc-modal-body-dialog">
            <div class="rc-modal-body-inner-dialog rc-border-thin">
              <Box :key="redraw + 1">
                <Row v-for="(row, rowIndex) in viewBodyData" :key="rowIndex">
                  <CellFactory :rowData="row.data" :showMissingRequirements="showMissingRequirements"
                    v-on:withValue="withFieldValue" v-on:withButtonPressed="withButtonPressed" />
                </Row>
              </Box>
            </div>
          </div>

          <div class="rc-modal-footer-dialog">
            <Box :key="redraw + 2">
              <Row v-for="(row, rowIndex) in viewFooterData" :key="rowIndex">
                <CellFactory :rowData="row.data" :showMissingRequirements="showMissingRequirements"
                  v-on:withValue="withFieldValue" v-on:withButtonPressed="withButtonPressed" />
              </Row>
            </Box>
          </div>
        </div>
      </div>
    </Column>
  </Row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ConnectionUtils from '@/utils/ConnectionUtils.js';
import ConstUtils from '@/utils/ConstUtils.js';
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';

import MC from "@/domain/session/MC.js";

import Column from "@/portals/shared/library/box/Column.vue";
import Row from "@/portals/shared/library/box/Row.vue";
import Box from "@/portals/shared/library/box/Box.vue";
import CellFactory from "@/portals/shared/cell/CellFactory.vue";

import BoxDisplayRow from "@/portals/shared/cell/box/BoxDisplayRow";
import RowDisplayRow from "@/portals/shared/cell/row/RowDisplayRow";

import TitleDisplayRow from "@/portals/shared/cell/title/TitleDisplayRow";
import ButtonDisplayRow from "@/portals/shared/cell/button/ButtonDisplayRow";
import ErrorDisplayRow from "@/portals/shared/cell/error/ErrorDisplayRow";
import SpacerDisplayRow from "@/portals/shared/cell/spacer/SpacerDisplayRow";
import StringUpdateRow from "@/portals/shared/cell/string/StringUpdateRow";
import StringDisplayRow from "@/portals/shared/cell/string/StringDisplayRow";

import Company from "@/domain/model/company/Company.js";

export default {
  name: "company-email-update-view",
  components: {
    Column,
    Row,
    Box,
    CellFactory,
  },
  props: {
    itemId: { type: String, default: "" },
    emailType: { type: String, default: "" },
  },
  data() {
    return {
      redraw: 1,
      MC: new MC(),
      Strings: StringUtils,
      Contents: ContentUtils,
      Consts: ConstUtils,

      company: null,
      currentEmail: "",

      showMissingRequirements: false,
      viewBodyData: [],
      viewFooterData: [],
      viewHeaderData: [],

      kvps: {},
      error: null,
      showDialog: null,
    };
  },
  computed: {
    ...mapGetters([
      'auth_connected',
      'auth_socket_status',
      'signin_event',
      'auth_client',
      'domain',
    ]),
  },
  mounted: function () {
    ConnectionUtils.ensureConnection(this);
  },
  watch: {
    auth_connected() {
      ConnectionUtils.sendSignInEvent(this);
    },
    auth_socket_status() {
      ConnectionUtils.displayStatus(this);
    },
    signin_event() {
      ConnectionUtils.createDomainSession(this);
    },
  },
  methods: {
    ...mapActions([
      'AuthStorage_updateCompany',
      'addListenerAction',
      'removeListenerAction',
      'updateDomain',
    ]),

    start: function () {
      this.comapny = new Company(this.domain);
      if (StringUtils.isNotEmpty(this.itemId)) {
        var id = ContentUtils.baseDecode(this.itemId);
        this.company = this.domain.companys().findById(id).copy();
      }
      this.setup();
      this.mainScreen();
    },

    setup: function () {
      // window.onclick = this.onClick;
    },

    mainScreen: function () {
      this.viewHeaderData = [];
      this.viewBodyData = [];
      this.viewFooterData = [];
      this.paint();

      var errorBox = new BoxDisplayRow().withBorder(true)
        .withChild(new RowDisplayRow()
          .withChild(new SpacerDisplayRow().withWidth("1"))
          .withChild(new ErrorDisplayRow().withWidth("13").withError(this.error))
          .withChild(new SpacerDisplayRow().withWidth("1"))
        );
      if (this.error) {
        this.viewBodyData.push(errorBox);
      }


      let titleRow = new RowDisplayRow().withWidth(15);
      let title = new TitleDisplayRow().withTitle("Add or Remove an Email").withWidth(15);
      titleRow.withChild(title);
      this.viewHeaderData.push(new BoxDisplayRow().withWidth(15).withChild(titleRow));


      let cancelButton = new ButtonDisplayRow().withWidth(3).withName("Cancel").withField("CloseDialog");
      let saveButton = new ButtonDisplayRow().withWidth(3).withName("Save").withField("Save").withBackgroundPrimaryAction();
      let footerRow = new RowDisplayRow().withWidth(15);
      footerRow.withChild(cancelButton);
      footerRow.withChild(new SpacerDisplayRow().withWidth(9));
      footerRow.withChild(saveButton);
      this.viewFooterData.push(new BoxDisplayRow().withWidth(15).withChild(footerRow));

      let emailBox = new BoxDisplayRow().withWidth(15);
      let emailRow = new RowDisplayRow().withWidth(15);
      let emailSearch = new StringUpdateRow().withField(this.emailType).withDefaultValue(this.currentEmail).withWidth(13);
      let emailButton = new ButtonDisplayRow().withWidth(2).withName("Add").withField("AddEmail").withBackgroundPrimaryAction();

      emailRow.withChild(emailSearch);
      emailRow.withChild(emailButton);
      let emails = this.getEmails();
      for (let i = 0; i < emails.length; i++) {
        let email = emails[i];
        let row = new RowDisplayRow().withWidth(15).withBorder(true).withBorderRadiusLarge().withElevationMedium();
        row.withChild(new StringDisplayRow().withAlignLeft().withValue(email).withWidth(14));
        row.withChild(new ButtonDisplayRow().withWidth(1).withName("X").withField("RemoveEmail").withKey(i));

        emailRow.withChild(row);
      }
      
      if (this.emailType === Company.FIELDS.EMAIL) {
        emailBox.addChild(new StringDisplayRow().withValue("Add or remove an email address of a person who should receive an email whenever a new Vehicle Inspection is created or changed.").withAlignLeft());

      } else if (this.emailType === Company.FIELDS.EMAIL_DEFECTS) {
        emailBox.addChild(new StringDisplayRow().withValue("Add or remove an email address of a person who should receive an email whenever a Vehicle Inspection has a Defect.").withAlignLeft());

      } else if (this.emailType === Company.FIELDS.EMAIL_EQUIPMENT) {
        emailBox.addChild(new StringDisplayRow().withValue("Add or remove an email address of a person who should receive an email whenever an Equipment Inspection is created or changes.").withAlignLeft());

      } else if (this.emailType === Company.FIELDS.EMAIL_EQUIPMENT_DEFECTS) {
        emailBox.addChild(new StringDisplayRow().withValue("Add or remove  an email address of a person who should receive an email whenever an Equipment Inspection has a Defect.").withAlignLeft());

      } else {
        emailBox.addChild(new StringDisplayRow().withValue("Add or remove an email address of the person who should receive an email").withAlignLeft());
      }

      emailBox.withChild(emailRow);

      this.viewBodyData.push(emailBox);

      this.paint();
    },

    getEmails: function () {
      let emails = [];
      let email = this.company.get(this.emailType);
      if (StringUtils.isNotEmpty(email)) {
        emails.push(...email.split(","));
      }
      return emails;
    },

    paint: function () {
      this.redraw++;
    },

    onClick: function (event) {
      var modal = document.getElementById("detailsModal");
      if (event.target == modal) {
        this.goBack();
      }
    },

    log() {
      return this.domain.logger();
    },

    resetMissingValues() {
      if (this.showMissingRequirements) {
        this.showMissingRequirements = false;
      }
    },

    callback: function (msg) {
      if (msg) {
        //
      }
    },

    areRequirementsMet() {
      var met = true;
      return met;
    },

    goBack: function () {
      this.$router.back();
    },

    withFieldValue: function (valueData) {
      this.currentEmail = valueData["value"];
      this.$emit("withValue", valueData);
    },

    withButtonPressed: function (buttonData) {
      if (buttonData["field"] === "CloseDialog") {
        this.$emit("withButtonPressed", buttonData);

      } else if (buttonData["field"] === "Save") {
        if (this.areRequirementsMet()) {
          this.sendingScreen();
          let operation = this.domain.events().companySave(this.company.data);
          let context = { view: this }
          operation.send(this.listener, context);
        } else {
          this.showMissingRequirements = true;
        }
      } else if (buttonData["field"] === "AddEmail") {
        let emails = this.getEmails();
        if (emails.includes(this.currentEmail)) {
          this.error = {
            messageId: "EmailAlreadyExists",
            hint: "Email already exists"
          };
          this.mainScreen();
          return;
        }
        if (StringUtils.isEmpty(this.currentEmail) || !StringUtils.isEmail(this.currentEmail)) {
          this.error = {
            messageId: "InvalidEmail",
            hint: "Email is invalid"
          };
          this.mainScreen();
          return;
        }
        this.error = null;
        emails.push(this.currentEmail);
        this.currentEmail = "";
        this.company.put(this.emailType, emails.join(","));
        this.mainScreen();
      } else if (buttonData["field"] === "RemoveEmail") {
        let emails = this.getEmails();
        emails.splice(buttonData["key"], 1);
        this.company.put(this.emailType, emails.join(","));
        this.mainScreen();
      }
      this.$emit("withButtonPressed", buttonData);
    },

    urlQueryParams() {
      return Object.assign({}, this.$route.query);
    },

    listener(notification, context) {
      this.doneScreen();
      if (!notification || !context) {
        return;
      }
      if (notification.error()) {
        this.error = notification.error();
        this.mainScreen();
        return;
      }

      var buttonData = {};
      buttonData["field"] = "CloseDialog";
      buttonData["refresh"] = true;
      this.$emit("withButtonPressed", buttonData);
    },

    sendingScreen() {
      this.viewBodyData = [];
      this.viewFooterData = [];
      this.viewHeaderData = [];

      let bodyBox = new BoxDisplayRow().withChild(new RowDisplayRow()
        .withChild(new SpacerDisplayRow().withWidth("2"))
        .withChild(new BoxDisplayRow()
          .withWidth("11")
          .withChild(new StringDisplayRow()
            .withValue("Sending"))
        )
        .withChild(new SpacerDisplayRow().withWidth("2"))
      );
      this.viewBodyData.push(bodyBox);
      this.paint();
    },

    doneScreen() {
      this.viewHeaderData = [];
      this.viewBodyData = [];
      this.viewFooterData = [];

      let bodyBox = new BoxDisplayRow().withChild(new RowDisplayRow()
        .withChild(new SpacerDisplayRow().withWidth("2"))
        .withChild(new BoxDisplayRow()
          .withWidth("11")
          .withChild(new StringDisplayRow()
            .withMandatoryValue(true)
            .withValue("Done!"))
        )
        .withChild(new SpacerDisplayRow().withWidth("2"))
      );

      this.viewBodyData.push(bodyBox);
      this.paint();
    },
  }
};

</script>